import { render } from "./BackerCenterUpdatesFeedView.vue?vue&type=template&id=1e5da622"
import script from "./BackerCenterUpdatesFeedView.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdatesFeedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__